import React from 'react';
import Form from '../../Shared/HubForm/Form';
import { inputs, whatList } from './data';
import profile1 from '../../../Assets/Cards/signupProfile.png';
import profile2 from '../../../Assets/Icons/cprofile2.png';
import {ReactComponent as Play} from '../../../Assets/Icons/sliderPlay.svg';

import './Styles/Container.scss';
import Section from '../Monzo/Section';
const Container=()=>{
    return(
        <div className="what-container">
            <div className="content">
                <h1>Free Webinar: Empower everyone in your company to solve problems, together.</h1>
                <div className="host">
                    <h1>Hosted by:</h1>
                    <ul>
                        <li>
                            <img src={profile1} />
                            <h3>Murat Mutlu</h3>
                            <p>CEO and Co-founder of Hostdesign</p>
                        </li>
                        <li>
                            <img src={profile2} />
                            <h3>Murat Mutlu</h3>
                            <p>CEO and Co-founder of Hostdesign</p>
                        </li>
                    </ul>
                </div>
                <Section
                title="Practical Design Thinking Workshop Kit"
                desc="In this free interactive webinar, Hostdesign’s CEO, Murat Mutlu, and Product Specialist, Zorast Gustavsp, will explain how you can run a simple, fun and hands-on workshop using the basic principles of Design Thinking. Empathise, define, ideate, prototype and test any solution with your team and wider organisation."
                />
                <div className="image-part">
                    <Play />
                </div>
                <h2>What you'll learn:</h2>
                <ul className="list"> 
                    {whatList.map((item) =>{
                        return(
                            <li>{item}</li>
                        )
                    })}
                </ul>
            </div>
            <Form list={inputs} btn="Watch Webinar" />
        </div>
    )
};
export default Container ;